/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { CoreUiExtSplitPaneModule } from '@gh/core-ui-ext/split-pane';
import { GanttChartTableComponent } from './components/gantt-chart-table/gantt-chart-table.component';
import { GanttChartTimelineComponent } from './components/gantt-chart-timeline/gantt-chart-timeline.component';
import { GanttChartComponent } from './components/gantt-chart/gantt-chart.component';
import {
  GridPredecessorCellEditorComponent,
} from './components/gantt-predecessor-cell-editor/gantt-predecessor-cell-editor.component';
import {
  GanttPredecessorKitDialogComponent,
} from './components/gantt-predecessor-kit-dialog/gantt-predecessor-kit-dialog.component';
import { GanttChartTimelineInstanceDirective } from './directives/gantt-chart-timeline-instance.directive';
import { GanttChartTimelineTemplateDirective } from './directives/gantt-chart-timeline-template.directive';
import { GanttChartTimelineDirective } from './directives/gantt-chart-timeline.directive';
import { GanttChartBusinessService } from './services/gantt-chart-business.service';
import { GanttChartLoader } from './services/gantt-chart-loader.service';
import { GanttChartRestService } from './services/gantt-chart-rest.service';
import { GanttEditTaskDialogComponent } from './components/gantt-edit-task-dialog/gantt-edit-task-dialog.component';
import {
  GanttConfirmDeleteDialogComponent,
} from './components/gantt-confirm-delete-dialog/gantt-confirm-delete-dialog.component';
import { FullscreenOverlayContainer, OverlayContainer } from '@angular/cdk/overlay';

@NgModule(
  {
    imports        : [
      CommonModule,
      BuilderSharedModule.forChild(),

      CoreUiExtSplitPaneModule,
    ],
    providers      : [
      GanttChartLoader,
      GanttChartBusinessService,
      GanttChartRestService,
      { provide: OverlayContainer, useClass: FullscreenOverlayContainer },
    ],
    declarations   : [
      GanttChartComponent,
      GanttChartTableComponent,
      GanttChartTimelineComponent,
      GanttChartTimelineDirective,
      GanttChartTimelineTemplateDirective,
      GanttChartTimelineInstanceDirective,
      GridPredecessorCellEditorComponent,
      GanttPredecessorKitDialogComponent,
      GanttEditTaskDialogComponent,
      GanttConfirmDeleteDialogComponent,
    ],
    exports        : [
      GanttChartComponent,
      GanttChartTableComponent,
      GanttChartTimelineComponent,
      GanttChartTimelineDirective,
      GanttChartTimelineTemplateDirective,
      GanttChartTimelineInstanceDirective,
    ],
  },
)
export class BuilderSharedGanttChartModule {

}
